import stripTrailingSlash from '@/core/utils/strip-trailing-slash';

const isBookingRootPathname = (pathname: string): boolean => {
  const cleanPath = stripTrailingSlash(
    pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?\//, '/').replace(/\?.*$/, ''),
  );

  return cleanPath === '/booking';
};

export default isBookingRootPathname;
